import colors from '../../styles/colors.scss';

export const getStatusTagColor = (status) => {
  const statusColorMap = {
    ACTIVE: colors.tag_blue,
    COMPLETED: colors.tag_color_harvested,
    HARVESTED: colors.tag_color_harvested,
    INACTIVE: colors.grey_text,
    DEFAULT: colors.tag_blue,
  };
  return statusColorMap[status] || statusColorMap['DEFAULT'];
};
